import moment from 'moment'

export default {
    namespaced: true,
    state: {
        date: 'today',
        board: 0,
        boards: ['Effektivitet', 'Bilpleje'],
        performancePeriod: 'I dag',
        range: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
    },
    getters: {
        board (state) {
            return state.boards[state.board]
        },
        period (state) {
            return state.periods[state.period]
        }
    }
}